<template>
  <div class="main-container">
    <div class="scroll height386" style="text-align: center">
      <Carousel dots="none" arrow="never" loop :on-change="carouseChange">
        <CarouselItem v-for="(img, index) in imageDate" :key="index">
          <!-- @click="clickImage(img)" -->
          <div class="demo-carousel" :style="`background-color:${img.bgColor}`">
            <a target="_blank" href="https://exam.cnset.com.cn/login">
              <img :src="getUrl(img.BannerImgUrl)" />
              <!-- {{img}} -->
              <!-- <img src="../assets/home/banner_index01.png" /> -->
            </a>
          </div>
        </CarouselItem>
      </Carousel>

      <!-- <div class="button-container">
        <img
          @click="explain()"
          style="margin-right: 16px"
          src="@/assets/home/button01.png"
          alt
        />

        <img
          @click="notification()"
          style="margin-right: 16px"
          src="@/assets/home/button02.png"
          alt
        />

        <img @click="rec()" src="@/assets/home/button03.png" alt />
      </div> -->
    </div>
    <div class="height386 bgf7">
      <div class="width1200 section1">
        <img src="@/assets/home/pic01_index.png" />
        <h1>紧贴英语教与学考量标准</h1>
        <h2>顺应英语口语测评趋势</h2>
        <List class="desc-list" :list="section1"></List>
      </div>
    </div>
    <div class="height386">
      <div class="width1200 section2">
        <img src="@/assets/home/pic02_index.png" />
        <h1>全国统一的测评标准</h1>
        <h2>更客观、更公正</h2>
        <List class="desc-list" :list="section2"></List>
      </div>
    </div>
    <div class="height528 bgf7 section3-container">
      <div class="width1200 section3">
        <!-- <img src="@/assets/home/pic03_index.png">-->
        <h1>全国数十位专家参与论证</h1>
        <h2>广受教育教研专家认可</h2>
        <List class="desc-list" type="2" :list="section3"></List>

        <Carousel
          dots="none"
          autoplay
          :autoplay-speed="3000"
          :on-change="carouseChange"
        >
          <CarouselItem>
            <ChildCell :childern="childern1"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern2"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern3"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern4"></ChildCell>
          </CarouselItem>

          <CarouselItem>
            <ChildCell :childern="childern5"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern6"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern7"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern8"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern9"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern10"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern11"></ChildCell>
          </CarouselItem>
          <CarouselItem>
            <ChildCell :childern="childern12"></ChildCell>
          </CarouselItem>
        </Carousel>
      </div>
    </div>
    <div class="height386">
      <div class="width1200 section4">
        <img src="@/assets/home/pic03_index.png" />
        <h1>依托口语人工智能自动评分技术</h1>
        <h2>让机考更便捷、更智能、更可信</h2>
        <List class="desc-list" :list="section4"></List>
      </div>
    </div>
    <div class="height386 bgf7">
      <div class="width1200 section5">
        <img src="@/assets/home/pic04_index.png" />
        <h1>GetV专业测评报告和证书</h1>
        <h2>清晰评估英语口语水平，指引成长空间</h2>
        <List class="desc-list" :list="section5"></List>
      </div>
    </div>
    <!-- <div class="height658">
      <div class="width1200 section6">
        <h1>英语教育专家证言</h1>
        <Carousel dots="none" loop :on-change="carouseChange">
          <CarouselItem>
            <IntroduceCell :introduce="introduce"></IntroduceCell>
          </CarouselItem>
        </Carousel>
      </div>
    </div> -->
    <div class="height386 section7-container">
      <div class="width1200 section7">
        <!-- <img src="@/assets/home/pic01_index.png"> -->
        <h1>国家课题</h1>
        <h2>
          CNSET英语口语能力人工智能分级测评教研组开展了多样化课题研究，探索中小学生英语听说能力提升的科学有效方案。
        </h2>
        <List class="desc-list" :list="section7"></List>
      </div>
    </div>
  </div>
</template>

<script>
import { getBanner } from "@/request/api.js";
import List from "@/components/public/List";
// import IntroduceCell from "@/components/homepage/IntroduceCell";
import ChildCell from "@/components/homepage/ChildCell";
export default {
  components: {
    List,
    // IntroduceCell,
    ChildCell,
  },
  created() {
    let that = this;
    getBanner().then((res) => {
      console.log(res);
      if (res.statusText == "OK") {
        that.imageDate = res.data;
        that.imageDate.forEach((item, index) => {
          item.bgColor = that.colors[index];
        });
      }
    });
  },
  data() {
    return {
      colors: ["#000b3c", "#f3be00", "#14514c"],

      imageDate: [],
      childern1: [
        {
          image: require("@/assets/home/zjw.png"),
          name: "张继伟",
        },
        {
          image: require("@/assets/home/tl.png"),
          name: "田黎",
        },
        {
          image: require("@/assets/home/gbz.png"),
          name: "高宝珠",
        },
      ],
      childern2: [
        {
          image: require("@/assets/home/qyq.png"),
          name: "乔玉全",
        },
        {
          image: require("@/assets/home/zlz.png"),
          name: "张连仲",
        },
        {
          image: require("@/assets/home/dys.png"),
          name: "丁延森",
        },
      ],
      childern3: [
        {
          image: require("@/assets/home/lyd.png"),
          name: "林远东",
        },
        {
          image: require("@/assets/home/djh.png"),
          name: "丁俊华",
        },
        {
          image: require("@/assets/home/xy.png"),
          name: "徐岩",
        },
      ],
      childern4: [
        {
          image: require("@/assets/home/sdw.png"),
          name: "孙大伟",
        },
        {
          image: require("@/assets/home/17.png"),
          name: "张小海",
        },
        {
          image: require("@/assets/home/18.png"),
          name: "张志明",
        },
      ],

      childern5: [
        {
          image: require("@/assets/home/1.png"),
          name: "董洪丹",
        },
        {
          image: require("@/assets/home/2.png"),
          name: "龚亚夫",
        },
        {
          image: require("@/assets/home/3.png"),
          name: "蒋媚",
        },
      ],
      childern6: [
        {
          image: require("@/assets/home/4.png"),
          name: "李晨",
        },
        {
          image: require("@/assets/home/5.png"),
          name: "李静纯",
        },
        {
          image: require("@/assets/home/6.png"),
          name: "李力",
        },
      ],
      childern7: [
        {
          image: require("@/assets/home/7.png"),
          name: "刘丽艳",
        },
        {
          image: require("@/assets/home/8.png"),
          name: "桑晓宁",
        },
        {
          image: require("@/assets/home/9.png"),
          name: "夏春娥",
        },
      ],
      childern8: [
        {
          image: require("@/assets/home/10.png"),
          name: "肖克义",
        },
        {
          image: require("@/assets/home/11.png"),
          name: "许时升",
        },
        {
          image: require("@/assets/home/12.png"),
          name: "杨义春",
        },
      ],
      childern9: [
        {
          image: require("@/assets/home/13.png"),
          name: "于钢",
        },
        {
          image: require("@/assets/home/14.png"),
          name: "虞建华",
        },
        {
          image: require("@/assets/home/15.png"),
          name: "禹海军",
        },
      ],
      childern10: [
        {
          image: require("@/assets/home/16.png"),
          name: "张绍杰",
        },
        {
          image: require("@/assets/home/19.png"),
          name: "丁薇",
        },
        {
          image: require("@/assets/home/20.jpg"),
          name: "何锋",
        },
      ],

      childern11: [
        {
          image: require("@/assets/home/21.jpg"),
          name: "扈华唯",
        },
        {
          image: require("@/assets/home/22.jpg"),
          name: "李萍",
        },
        {
          image: require("@/assets/home/23.jpg"),
          name: "李正栓",
        },
      ],

      childern12: [
        {
          image: require("@/assets/home/24.jpg"),
          name: "张达",
        },
        {
          image: require("@/assets/home/25.jpg"),
          name: "张涛",
        },
      ],

      introduce: [
        {
          image: require("@/assets/home/dxm.png"),
          name: "杜效明",
          title: "安徽省教育学会外语教学专业委员会",
          des:
            "思恩特口语测评标准的提出非常好，这套标准是基于全国大数据的整理，集思广益形成完备的语料库。当然，光有测评方案还不够，还要有细化的标准，对一线教学才会有重大意义，才能推动全国各地英语教育朝着更好的方向发展。",
        },
        {
          image: require("@/assets/home/zd.png"),
          name: "张达",
          title: "辽宁省外国语协会会长 ",
          des:
            "《英语口语能力人工智能分级测评计算机测评标准》对于教育行业意义重大，是全国外语界的大事，也让我们对外语教育充满信心，必须全力支持。",
        },
        {
          image: require("@/assets/home/dw.png"),
          name: "丁薇",
          title: "吉林省外语学会 ",
          des:
            "标准的建立将起到风向标的作用，这个工作很复杂，做好了能够有效推进信息技术和教育的深度融合。",
        },
        {
          image: require("@/assets/home/zt.png"),
          name: "张涛",
          title: "山东省教育学会外语教学专业委员会",
          des:
            "标准细化很重要，这样才能有很强的指导性，有清晰的目标，各地拿到之后就知道怎么去执行。技术与教育深度结合，让标准发挥更大作用。",
        },
      ],
      section1: [
        "等级划分对接《中国英语能力等级量表》，清晰反馈学生真实学情；",
        "考核内容以我国中小学英语课程标准为依据，与日常课堂教学相辅相成；",
        "测评技术与中高考口语机考技术同根同源，帮助学生提前熟悉机考模式；",
      ],
      section2: [
        "标准化考点、统一软硬件配置、标准化测评流程、标准化考务、考培体系；",
        "历经八年数据前测，积累大量语料数据，测评标准更客观、更权威；",
        "全国统一标准，帮助各地师生清晰知晓在全国的口语水平和提升空间；",
        "多维评价体系，从基础词汇发音到语篇韵律度，考查英语口语能力方方面面；",
      ],
      section3: [
        "20多个教育大省的英语教研专家联合参与论证共同参与制定标准细则",
        "基于英语教学形成的科学测评体系，让技术平台与教学应用相辅相成",
      ],
      section4: [
        "超过7年的口语测评实战经验，在全国多地中小学校成功施测；",
        "达到大规模高利害关系口语测评中成功应用的性能标准；",
        "采用驰声科技“声动之芯”打分技术，不同题型采用不同维度的评测标准无需人工评分，支持封闭题型、半开放题型和开放题型；",
      ],
      section5: [
        "基于语音云大数据，综合分析实时给出测评报告，支持个人测试数据报告和集体报告；",
        "学生可以获得全面、客观的评价报告，便于调整学习计划，逐级突破；",
        "老师基于测试数据，进行个性化的教学，提升教学质量；",
      ],
      section7: [
        "北京市教育学会“十三五”教育科研滚动课题:《基于北京市英语中考标准的学生英语听说能力训练系统研究》以及《基于北京市英语中考标准的学生英语听说能力诊断报告研究》;",
        "中国教育发展战略学会教师发展专业委员会重点课题:《中小学英语口语能力等级计算机测评标准研究》;",
      ],
      value2: 0,
    };
  },
  computed: {
    backgroundColor() {
      return "#ff0000";
    },
  },
  methods: {
    explain() {
      window.open("https://www.cnset.com.cn/material/报名流程.pdf");
    },
    notification() {
      window.open("https://www.cnset.com.cn/material/通知.pdf");
    },
    rec() {
      window.open(
        "https://www.cnset.com.cn/material/报名培训中心申请办法.pdf",
        "_blank1"
      );
      // window.open(
      //   "https://www.cnset.com.cn/material/地市级组委会申请办法.pdf",
      //   "_blank2"
      // );
      // window.open(
      //   "https://www.cnset.com.cn/material/考点申请申请办法.pdf",
      //   "_blank3"
      // );
    },
    clickImage(image) {
      this.$router.push({
        path: "/detail",
        query: { dID: image.BannerContentUrl },
      });
    },
    getUrl(url) {
      return window.API_URL + url;
    },
    carouseChange(oldValue, newValue) {
      console.log(oldValue, newValue);
    },
  },
};
</script>
<style lang="less" scoped>
.main-container {
  // background-color: red;
  // width: 1200px;
  margin: 0 auto;
  .button-container {
    position: absolute;
    top: 230px;
    // padding-left: 205px;
    cursor: pointer;
    width: 1440px;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    padding-left: 180px;
  }
  .scroll {
    position: relative;
    .message {
      position: absolute;
      width: 100%;
      height: 42px;
      background-color: #33333333;
      // opacity: 0.4;
      top: 342px;
      color: white;
      // text-align: center;
      .message-text {
        width: 1200px;
        margin: 0 auto;
        padding: 10px;
        text-align: left;
      }
      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }
  .demo-carousel {
    height: 385px;
    width: 100%;
    cursor: pointer;
    display: flex;
    justify-content: space-around;
    img {
      margin: 0 auto;
    }
  }
  .height528 {
    height: 528px;
  }
  .height658 {
    height: 658px;
  }
  .height386 {
    height: 386px;
    .imgbt1 {
      transform: translate(210px, -280px);
      cursor: pointer;
      &:hover {
        transform: translate(210px, -280px) scale(1.05);
        transition: all 0.2s;
      }
    }
    .imgbt2 {
      transform: translate(150px, -280px);
      cursor: pointer;
      &:hover {
        transform: translate(150px, -280px) scale(1.05);
        transition: all 0.2s;
      }
    }
  }
  .width1200 {
    width: 1200px;
    margin: 0 auto;
  }
  .bgf7 {
    background-color: #f7f7f7;
  }
  h1 {
    font-size: 38px;
    color: #344f97;
    font-weight: 400;
  }
  h2 {
    font-size: 24px;
    color: #555555;
    font-weight: 400;
  }
  .section1 {
    position: relative;
    img,
    h1,
    h2,
    .desc-list {
      position: absolute;
    }
    img {
      left: 29px;
      top: 71px;
    }
    h1 {
      left: 190px;
      top: 127px;
    }
    h2 {
      left: 190px;
      top: 178px;
    }
    .desc-list {
      right: 0;
      top: 122px;
      left: 631px;
    }
  }
  .section2 {
    position: relative;
    img,
    h1,
    h2,
    .desc-list {
      position: absolute;
    }
    img {
      left: 851px;
      top: 36px;
    }
    h1 {
      left: 595px;
      top: 199px;
    }
    h2 {
      left: 716px;
      top: 250px;
    }
    .desc-list {
      top: 110px;
      left: 60px;
    }
  }
  .section3-container {
    background: url("../assets/home/bg_banner02_index.png") no-repeat;
    background-size: 100% 100%;
  }
  .section3 {
    // position: relative;

    .desc-list {
      width: 525px;
      margin: 20px auto;
    }
    h1 {
      padding-top: 34px;
      font-size: 38px;
      color: #f7f7f7;
      text-align: center;
    }

    h2 {
      font-size: 24px;
      color: #f7f7f7;
      opacity: 0.8;
      text-align: center;
      font-size: 16px;
    }
  }
  .section4 {
    position: relative;
    img,
    h1,
    h2,
    .desc-list {
      position: absolute;
    }
    img {
      left: 65px;
      top: 151px;
    }
    h1 {
      left: 59px;
      top: 64px;
    }
    h2 {
      left: 60px;
      top: 116px;
    }
    .desc-list {
      top: 98px;
      left: 611px;
    }
  }
  .section5 {
    position: relative;
    img,
    h1,
    h2,
    .desc-list {
      position: absolute;
    }
    img {
      left: 863px;
      top: 50px;
    }
    h1 {
      left: 64px;
      top: 77px;
    }
    h2 {
      left: 64px;
      top: 130px;
    }
    .desc-list {
      top: 182px;
      left: 70px;
    }
  }
  .section6 {
    padding: 0 80px;
    h1 {
      text-align: center;
      margin: 50px;
    }
  }
  .section7-container {
    // background: url("../assets/home/bg_banner03_index.png") no-repeat;
    // background-size: 100% 100%;
  }
  .section7 {
    position: relative;
    img,
    h1,
    h2,
    .desc-list {
      position: absolute;
    }
    h1 {
      top: 32px;
      left: 0;
      right: 0;
      text-align: center;
    }
    h2 {
      top: 88px;
      left: 0;
      right: 0;
      text-align: center;
      font-size: 18px;
      color: #344f97 !important;
    }
    .desc-list {
      top: 130px;
      left: 112px;
    }
    // img {
    //   left: 149px;
    //   top: 71px;
    // }
    // h1 {
    //   left: 184px;
    //   top: 77px;
    // }
    // h2 {
    //   left: 184px;
    //   top: 130px;
    // }
    // .desc-list {
    //   top: 182px;
    //   left: 190px;
    // }
  }
}
</style>
